import axios from 'axios';

import type { ListAssetsQueryT, ListAssetsResT } from 'server/controllers';

import { P_API_ASSETS, getServerServices } from 'utils';

const ss = getServerServices();

export async function listAssets({
  userId,
}: ListAssetsQueryT): Promise<ListAssetsResT> {
  if (ss) {
    return {
      assets: await ss.listAssets({ owner: userId }),
    };
  }

  const res = await axios.get<ListAssetsResT>(
    P_API_ASSETS,
    {
      params: {
        userId,
      } satisfies ListAssetsQueryT,
    },
  );

  return res.data;
}
